export function createQuery(host, term, type, cpuCount) {
  if (type === 'snmp') {
    return `from(bucket: "telegraf")
      |> range(start:-15m, stop: now())
      |> filter(fn: (r) => r["_measurement"] == "snmp")
      |> filter(fn: (r) => r["_field"] == "${term}")
      |> filter(fn: (r) => r["agent_host"] == "${host}")
      |> last()
      |> map(fn: (r) => ({ r with _value: r._value / float(v: ${cpuCount}) }))`;
  } 
  else {
    return `from(bucket: "telegraf")
      |> range(start:-15m, stop: now())
      |> filter(fn: (r) => 
          r["_measurement"] == "ezelink_load_longterm" or 
          r["_measurement"] == "ezelink_load_midterm" or 
          r["_measurement"] == "ezelink_load_shortterm"
      )
      |> map(fn: (r) => ({
          r with
          term: if r._measurement == "ezelink_load_longterm" then "longterm"
                else if r._measurement == "ezelink_load_midterm" then "midterm"
                else if r._measurement == "ezelink_load_shortterm" then "shortterm"
                else "unknown",
      }))
      |> filter(fn: (r) => r["term"] == "${term}")
      |> filter(fn: (r) => r["host"] == "${host}")
      |> last()
      |> map(fn: (r) => ({ r with _value: (r._value / float(v: ${cpuCount}))*100.0 }))`;
  }
}
